import {
  LoginRequestPayload,
  NameMemberRecommendRequestPayload,
  RecommendBooksResponse,
} from "../types/User";
import axios from "./axios";

const DIRECT_RECOMMEND_TIMEOUT_MS = 20_000;

const requestLogin = async <T>(payload: LoginRequestPayload) => {
  return axios.get<T>("/web/getRecommendBooks", {
    params: {
      user_id: payload.user_id,
      password: payload.password,
      manage_code: payload.manage_code,
    },
  });
};

export const getUserAndBooks = async (payload: LoginRequestPayload) => {
  const response = await requestLogin<RecommendBooksResponse>(payload);
  return response.data;
};

const requestNameMemberRecommend = async <T>(
  payload: NameMemberRecommendRequestPayload,
  signal: AbortSignal
) => {
  const params = new URLSearchParams({
    user_name: payload.user_name,
    user_no: payload.user_no,
    manage_code: payload.manage_code,
  });

  return axios.get<T>("/web/user/getRecommendBooks", {
    params,
    signal,
    timeout: DIRECT_RECOMMEND_TIMEOUT_MS,
  });
};

export const getUserAndBooksByNameAndMemberNo = async (
  payload: NameMemberRecommendRequestPayload,
  signal: AbortSignal
) => {
  const response = await requestNameMemberRecommend<RecommendBooksResponse>(payload, signal);
  return response.data;
};
